"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _helpers = require("../../../../utils/helpers");

var _CardBadge = require("./CardBadge.style");

var CardBadge = function CardBadge(_ref) {
  var label = _ref.label,
      variant = _ref.variant,
      bookmark = _ref.bookmark,
      onClickLabel = _ref.onClickLabel;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  var hasBookmark = !!bookmark;
  var hasLabelClick = !!onClickLabel;
  return /*#__PURE__*/_react.default.createElement(_CardBadge.BadgeWrap, {
    variant: variant,
    hasBookmark: hasBookmark,
    hasLabelClick: hasLabelClick
  }, label && /*#__PURE__*/_react.default.createElement(_CardBadge.BadgeText, {
    hasLabelClick: hasLabelClick,
    onClick: function onClick(e) {
      e.preventDefault();

      if (hasLabelClick) {
        onClickLabel();
      }
    },
    size: cards.cardBadgeTextSize
  }, (0, _helpers.ellipsify)(label, 30)));
};

CardBadge.propTypes = {
  label: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['article', 'list', 'product', 'profile', 'signpost', 'signpostText']),
  bookmark: _propTypes.default.shape({
    isActive: _propTypes.default.bool,
    onClick: _propTypes.default.func
  }),
  onClickLabel: _propTypes.default.func
};
CardBadge.defaultProps = {
  label: '',
  variant: 'product',
  bookmark: null,
  onClickLabel: null
};
var _default = CardBadge;
exports.default = _default;